import { FC } from 'react';
import { useRouter } from 'next/router';
import { Text } from '@mofid-securities/uikit';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { Divider } from '@/components/Divider';
import { useRegister } from '../../hooks/useRegister';
import { TRedirectData } from '../../types';

interface IEkycApprovalBottomsheetProps {
  currentStepPayload: TRedirectData;
}

const EkycApprovalBottomsheet: FC<IEkycApprovalBottomsheetProps> = ({
  currentStepPayload,
}) => {
  const { handleRegisterLogic } = useRegister();
  const router = useRouter();
  const shouldReUploadVideo =
    currentStepPayload?.message?.messageType === 'RejectEkyc';

  const handleSubmit = () => {
    BottomSheet.close();
    if (shouldReUploadVideo) {
      const redirectData = { ...currentStepPayload, message: null };
      handleRegisterLogic(redirectData);
    } else {
      router.push('/');
    }
  };

  return (
    <div className="flex flex-col gap-y-4">
      <Text color="gray-120" size="sm" weight="regular">
        {currentStepPayload?.message?.message}
      </Text>
      <Divider />
      <Button isFullWidth onClick={handleSubmit}>
        ادامه
      </Button>
    </div>
  );
};

export const openEkycApprovalBottomsheet = (
  ekycApprovalBottomSheetProps: TRedirectData
) => {
  return BottomSheet.open({
    children: (
      <EkycApprovalBottomsheet
        currentStepPayload={ekycApprovalBottomSheetProps}
      />
    ),
  });
};
